import React from "react";
import MasterDataListPage from "../MasterDataListPage";

export default function QualityPage() {
    return (
        <MasterDataListPage
            title="Master Data"
            subtitle="คุณภาพสินค้า"
            apiPath="/qualities" 
            fieldKey="name"
            createDefaultName="รายการใหม่" 
            initialItems={[]}
        />
    );
}
